import {useQuery} from '@tanstack/react-query'

import {getRestaurantCategoryList} from '@/lib/food-grubhub/foodGrubhubService'
import type {CategoryListQuery} from '@/lib/food-grubhub/foodRestaurantDetailModel'

const useGrubhubGetCategoryList = (params: CategoryListQuery, token: string) => {
  return useQuery({
    queryKey: ['restaurant_category_detail', params, token],
    queryFn: async () =>
      getRestaurantCategoryList({
        orderType: params.orderType,
        platform: params.platform,
        enhancedFeed: params.enhancedFeed,
        weightedItemDataIncluded: params.weightedItemDataIncluded,
        location: params.location,
        viewport: params.viewport,
        restaurantId: params.restaurantId,
        token,
        signal: undefined,
      }),
    enabled: !!token,
    placeholderData: keepPreviousData,
  })
}

export default useGrubhubGetCategoryList
